import { Heading } from '@efdigital/ll-addon-ui';
import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import CoacheeCard from '@efdigital/ll-xceed-v2/components/coaching/coach/coachee-card.gts';
import type { CoachingCoachCoacheesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachCoacheesIndexSignature {
  Args: {
    model: CoachingCoachCoacheesModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coachees"}}

  <div class={{PAGE_WRAPPER}}>
    <Heading
      @size="lg"
      @text="Coachees"
      @secondary="Everyone who has shortlisted you for a chemistry call or chosen you as their coach."
      @class="mb-4"
    />

    {{#if @model.coachees.length}}
      <div class="row g-3 g-xl-4 align-items-stretch">
        {{#each @model.coachees as |coachee|}}
          <div class="col-12 col-lg-6 col-xl-4">
            <CoacheeCard @coachee={{coachee}} />
          </div>
        {{/each}}
      </div>
    {{else}}
      <EmptyState
        @message="You have no coachees yet. They appear here once a learner shortlists you for a chemistry call."
        @icon="ph:users"
      />
    {{/if}}
  </div>
</template> satisfies TOC<CoachingCoachCoacheesIndexSignature>;
